import React, { useState } from 'react';
import { createUser } from '../services/chatService';

const Setup = ({ onSetupComplete, onClose }) => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        handle: '',
        code: '',
        confirmCode: '',
        name: '',
        email: ''
    });
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setError('');
    };

    const handleCodeChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 4);
        setFormData(prev => ({
            ...prev,
            code: value
        }));
        setError('');
    };

    const handleConfirmCodeChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 4);
        setFormData(prev => ({
            ...prev,
            confirmCode: value
        }));
        setError('');
    };

    const handleNext = () => {
        if (step === 1) {
            if (!formData.handle.trim()) {
                setError('Please enter a handle');
                return;
            }
            setStep(2);
        } else if (step === 2) {
            if (formData.code !== formData.confirmCode) {
                setError('Codes do not match');
                return;
            }
            if (formData.code.length !== 4) {
                setError('Code must be 4 digits');
                return;
            }
            setStep(3);
        } else if (step === 3) {
            if (!formData.name.trim() || !formData.email.trim()) {
                setError('Please fill in all fields');
                return;
            }
            completeSetup();
        }
    };

    const completeSetup = async () => {
        try {
            // Create user in Firebase
            const newUser = await createUser(formData.name, formData.handle, formData.code, formData.email);

            // Save to localStorage for local session
            const userData = {
                id: newUser.id,
                handle: newUser.handle,
                code: newUser.code,
                name: newUser.name,
                email: newUser.email,
                isOnline: true,
                createdAt: newUser.createdAt
            };
            localStorage.setItem('currentUser', JSON.stringify(userData));

            onSetupComplete(userData);
        } catch (error) {
            console.error('Setup error:', error);
            setError('Failed to create account. Please try again.');
        }
    };

    const handleBack = () => {
        if (step > 1) {
            setStep(step - 1);
            setError('');
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && onClose) {
            onClose();
        }
    };

    return (
        <div className="setup-container" onClick={handleBackdropClick}>
            <div className="setup-window">
                <div className="setup-header">
                    <h1>Welcome to GOOD VIBES* #ccfc!</h1>
                    <p>Let's get you set up</p>
                    {onClose && (
                        <button className="close-setup" onClick={onClose}>×</button>
                    )}
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${(step / 3) * 100}%` }}
                        ></div>
                    </div>
                    <p className="step-indicator">Step {step} of 3</p>
                </div>

                <div className="setup-content">
                    {step === 1 && (
                        <div className="setup-step">
                            <h2>Choose Your Handle</h2>
                            <p>This is how others will find you</p>
                            <div className="form-group">
                                <label htmlFor="handle">Handle</label>
                                <input
                                    type="text"
                                    id="handle"
                                    name="handle"
                                    value={formData.handle}
                                    onChange={handleInputChange}
                                    placeholder="Enter your unique handle"
                                    className="setup-input"
                                />
                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="setup-step">
                            <h2>Create Your 4-Digit Code</h2>
                            <p>This will be your secure access code</p>
                            <div className="form-group">
                                <label htmlFor="code">4-Digit Code</label>
                                <input
                                    type="text"
                                    id="code"
                                    name="code"
                                    value={formData.code}
                                    onChange={handleCodeChange}
                                    placeholder="0000"
                                    maxLength="4"
                                    className="setup-input code-input"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="confirmCode">Confirm Code</label>
                                <input
                                    type="text"
                                    id="confirmCode"
                                    name="confirmCode"
                                    value={formData.confirmCode}
                                    onChange={handleConfirmCodeChange}
                                    placeholder="0000"
                                    maxLength="4"
                                    className="setup-input code-input"
                                />
                            </div>
                        </div>
                    )}

                    {step === 3 && (
                        <div className="setup-step">
                            <h2>Personal Information</h2>
                            <p>Tell us a bit about yourself</p>
                            <div className="form-group">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Enter your full name"
                                    className="setup-input"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Enter your email"
                                    className="setup-input"
                                />
                            </div>
                        </div>
                    )}

                    {error && <div className="error-message">{error}</div>}

                    <div className="setup-buttons">
                        {step > 1 && (
                            <button
                                type="button"
                                onClick={handleBack}
                                className="setup-button back-button"
                            >
                                Back
                            </button>
                        )}
                        <button
                            type="button"
                            onClick={handleNext}
                            className="setup-button next-button"
                        >
                            {step === 3 ? 'Complete Setup' : 'Next'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Setup;
